import { X, AlertTriangle } from "lucide-react";
import { useState } from "react";
import { CgSpinner } from "react-icons/cg";

const ConfirmCancelModal = ({
  isOpen,
  isCancelling,
  job,
  onClose,
  onConfirm,
}) => {
  const [reason, setReason] = useState("");

  if (!isOpen || !job) return null;

  const handleConfirm = () => {
    if (!reason.trim()) return;
    onConfirm(reason.trim());
    setReason("");
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-3 ">
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-[420px] bg-white rounded-2xl p-6 space-y-5 animate-modal-in shadow-xl "
      >
        {/* Header */}
        <div className="relative text-center">
          <button
            onClick={onClose}
            className="absolute right-0 top-0 p-1 rounded-full active:bg-gray-100"
          >
            <X size={18} />
          </button>

          <div className="mx-auto w-12 h-12 rounded-full bg-red-50 flex items-center justify-center mb-3">
            <AlertTriangle className="text-red-500" size={22} />
          </div>

          <h3 className="text-lg font-semibold text-primaryTextColor">
            Mark Yourself Unavailable?{" "}
          </h3>
          <p className="text-sm text-secondaryTextColor mt-1">
            Please tell us why you are unavailable for this job ? This helps
            keep records clear.
          </p>
        </div>

        {/* Reason Input */}
        <div className="space-y-1.5">
          <label className="text-sm font-medium text-primaryTextColor">
            Unavailability Reason <span className="text-red-500">*</span>
          </label>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={3}
            placeholder="e.g. location issue, emergency…"
            className=" w-full resize-none rounded-xl border border-gray-300 px-3 py-2.5 text-sm outline-none focus:ring-1 focus:ring-red-600 "
          />
        </div>

        {/* Actions */}
        <div className="space-y-3 pt-2">
          <button
            onClick={handleConfirm}
            disabled={!reason.trim() || isCancelling}
            className={`w-full h-12 rounded-xl font-semibold text-white transition ${
              reason.trim()
                ? "bg-red-600 active:bg-red-700"
                : "bg-red-300 cursor-not-allowed"
            }
            `}
          >
            {isCancelling ? (
              <div className="flex items-center justify-center gap-1">
                <CgSpinner className="animate-spin" size={18} />
                Cancelling
              </div>
            ) : (
              "Yes, Mark Unavailable"
            )}
          </button>

          <button
            onClick={onClose}
            className=" w-full h-10 rounded-xl text-secondaryTextColor font-medium active:bg-gray-100 "
          >
            Keep Job
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmCancelModal;

// import { X, AlertTriangle } from "lucide-react";
// import { useModalAccessibility } from "../../../hooks/useModalAccessibility";

// const ConfirmCancelModal = ({ isOpen, job, onClose, onConfirm }) => {
//   const modalRef = useModalAccessibility(isOpen, onClose);

//   if (!isOpen || !job) return null;

//   return (
//     <div
//       className="fixed inset-0 z-50 flex items-center justify-center bg-black/40"
//       onClick={onClose}
//     >
//       <div
//         ref={modalRef}
//         onClick={(e) => e.stopPropagation()}
//         className="w-[92vw] max-w-[420px] bg-white rounded-2xl p-6 space-y-5 animate-modal-in shadow-xl"
//       >
//         <div className="relative text-center">
//           <button
//             onClick={onClose}
//             className="absolute right-0 top-0 p-1 rounded-full active:bg-gray-100"
//           >
//             <X size={18} />
//           </button>

//           <AlertTriangle className="mx-auto text-red-500 mb-2" />
//           <h3 className="text-lg font-semibold text-gray-900">Cancel Job?</h3>
//           <p className="text-sm text-gray-600">This action cannot be undone.</p>
//         </div>

//         <button
//           onClick={onConfirm}
//           className="w-full h-12 rounded-xl bg-red-600 text-white font-semibold"
//         >
//           Yes, Cancel Job
//         </button>

//         <button
//           onClick={onClose}
//           className="w-full h-10 text-secondaryTextColor font-medium"
//         >
//           Keep Job
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ConfirmCancelModal;
